import Vue from 'vue';
import { api } from '../../helpers/api';
import doDecrypt from '../../helpers/decrypt';
// eslint-disable-next-line import/no-cycle
import router from '../../routes';

const setProfileData = (profileData, commit) => {
  const { apiToken, user } = profileData;
  const {
    parent, agent, additionalAccess, roles,
  } = user;

  const email = user?.parent?.email || user?.agent?.email || user?.additionalAccess?.email || '';
  const id = user?.parent?.id || user?.agent?.id || user?.additionalAccess?.id || null;

  const onboarding = {
    onboardingDesktop: user?.parent?.onboardingDesktop,
    onboardingMobile: user?.parent?.onboardingMobile,
  };

  const userData = {
    roles, email, id, onboarding,
  };

  commit('setToken', apiToken);
  commit('setUser', userData);

  if (parent) {
    commit('students/setStudents', parent.students, { root: true });
  }
  if (agent) {
    commit('setAgentData', agent);
  }
  if (additionalAccess) {
    commit('setAdditionalAccessData', additionalAccess);
  }
};

export default {
  async login({ commit }, params) {
    const response = await api.post('parent/auth/login', params);

    setProfileData(response.data.results, commit);
  },

  async logout({ dispatch }) {
    await api.get('parent/auth/logout');
    dispatch('clearStore');
    dispatch('clearAuth');
    if (router.currentRoute.name !== 'Auth.Login') {
      router.push({ name: 'Auth.Login' });
    }
  },

  clearAuth({ commit }) {
    // students
    commit('students/clearStudents', null, { root: true });
    commit('students/clearStudent', null, { root: true });
    commit('clearAuth');
  },

  clearStore({ commit }) {
    // students
    commit('students/clearStudents', null, { root: true });
    commit('students/clearStudent', null, { root: true });
    // lessons
    commit('lessons/clearLesson', null, { root: true });
    commit('lessons/clearLessons', null, { root: true });
    // homeworks
    commit('homeworks/clearHomeworks', null, { root: true });
    // grades
    commit('grades/clearGrades', null, { root: true });
    // attendances
    commit('attendances/clearAttendances', null, { root: true });
    // materials
    commit('materials/clearRealizations', null, { root: true });
    commit('materials/clearAllMaterials', null, { root: true });
  },

  async requestNewPassword(store, params) {
    await api.post('parent/password/request-new-password', params);
  },

  async checkToken(store, params) {
    const response = await api.post('parent/password/check-confirmation-token', params);
    return response.data.results;
  },

  async resetPassword(store, params) {
    await api.post('parent/password/reset-password', params);
  },

  async changePassword(store, params) {
    await api.post('parent/me/password', params);
  },

  async getRefundData(store, params) {
    const { kidId } = params || undefined;

    if (!kidId) {
      return undefined;
    }

    const response = await api.get(`parent/me/students/refundData/${kidId}`);

    const { data } = response || undefined;

    return data;
  },

  async updateRefundData(store, params) {
    try {
      const {
        kidId, fullName, bankAccountNumber, students,
      } = params || {};

      if (!kidId || !fullName || !bankAccountNumber || !students) {
        return false;
      }

      await api.post(`parent/me/students/refundData/${kidId}`, {
        fullName,
        bankAccountNumber,
        students,
      });
      return true;
    } catch (error) {
      console.error('Error updating refund data:', error);
      return false;
    }
  },

  async firstPassword({ commit }, params) {
    const response = await api.post('parent/password/first-password', params);

    setProfileData(response.data.results, commit);
  },

  async officeLogin({ commit, dispatch }) {
    dispatch('clearStore');
    dispatch('clearAuth');
    const { apiToken, kidId } = await dispatch('getDataFromCookie');
    if (!apiToken || !kidId) return { name: 'Error', params: { noPreview: true } };
    commit('setToken', apiToken);
    try {
      const {
        data: { results: student },
      } = await api.get(`parent/me/students/${kidId}`);
      await dispatch('materials/loadAllMaterials', null, { root: true });
      commit('setOfficeLogin', true);
      commit('students/setStudent', student, { root: true });
      const userData = { roles: ['ROLE_PARENT'], email: '' };
      commit('setUser', userData);
      commit('setCurrentProfile', 'ROLE_PARENT');
      commit('setAccess', student.access);
      commit('materials/setRealizations', student.applications, { root: true });
      if (student.group?.hasHomeworks) {
        return { name: 'Main.Homeworks', params: { kidId: student.id } };
      }
      return { name: 'Main.Attendances' };
    } catch {
      return { name: 'Error', params: { noPreview: true } };
    }
  },

  async getDataFromCookie() {
    const authToken = Vue.$cookies.get('auth-online');
    if (!authToken) return false;
    const decryptedAuthToken = doDecrypt(authToken);
    return decryptedAuthToken;
  },
  clearCurrentProfile({ commit }) {
    commit('clearCurrentProfile');
  },
  clearAgentData({ commit }) {
    commit('clearAgentData');
  },
  clearAdditionalAccessData({ commit }) {
    commit('clearAdditionalAccessData');
  },
};
